import {Tooltip as MuiTooltip,} from "@mui/material";

import React, {ReactElement} from "react";
import {useTheme} from "@mui/material/styles";

interface TooltipProps {
    title?: string;
    children: ReactElement<any, any>;

    [key: string]: any;
}

export const StyledTooltip: React.FC<TooltipProps> = props => {
    const theme = useTheme();

    return <MuiTooltip
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: "#3d3d3d",
                        color: 'rgba(255,255,255,0.87)',
                        boxShadow: theme.shadows[1],
                        fontSize: 14,
                        padding: "6px 10px",
                        marginTop: 5,
                    }
                }
            }}
            title={props.title}
            {...props}
    />
};

export const Tooltip: React.FC<TooltipProps> = ({title, children, ...rest}) =>
        (title ? <StyledTooltip title={title} {...rest}>{children}</StyledTooltip> : <>{children}</>);
